class CrearCuenta extends HTMLElement {
  constructor() {
    super();
    this.iconos = {
      iconCheckBoxOff: `${window.shopIcons.icon_checkbox_off}`,
      iconCheckBoxOn: `${window.shopIcons.icon_checkbox_on}`,
    };
    this.coordenadas = { lat: -17.51041339757574, lng: -63.16460460559482 };
    this.direccionSeleccionada = false;
    this.marcadorMovible = null;
  }

  connectedCallback() {
    // CAPTURAR ELEMENTOS
    this.modalBackground = this.querySelector('#phpcc-modal-background');
    this.contenedorTerminosCondiciones = this.querySelector('#phpcc-termino-condiciones');
    this.contenedorGeneralMiUbicacion = this.querySelector('#phpcc-modal-dar-direccion');
    this.contenedorModalBody = this.querySelector('#phpcc-contenido-modal-body');
    this.btnMiUbicacionActual = this.querySelector('#phpcc-btn-mi-ubicacion-actual');
    this.btnCerrarModalMiUbicacion = this.querySelector('#phpcc-boton-cerrar-modal');
    this.contenedorMapaMiUbicacion = this.querySelector('#phpcc-modal-mapa');
    this.btnContinuar = this.querySelector('#phpcc-btn-continuar');
    this.btnConfirmarModal = this.querySelector('#phpcc-btn-confirmar-modal');
    this.btnCancelarModal = this.querySelector('#phpcc-btn-cancelar-modal');
    this.inputDireccion = this.querySelector('#phpcc-input-direccion');
    this.contenedorSugerencias = this.querySelector('#phpcc-sugerencias-direccion');
    this.btnHutCoins = this.querySelector('#phpcc-btn-hutcoins');
    this.btnInfoHutCoins = this.querySelector('#phpcc-btn-info-hutcoins');
    // FORMULARIO GENERAL
    this.frmNombre = this.querySelector('#phpcc-frm-nombre');
    this.frmNombreInput = this.querySelector('#phpcc-frm-nombre-input');
    this.frmApellido = this.querySelector('#phpcc-frm-apellido');
    this.frmApellidoInput = this.querySelector('#phpcc-frm-apellido-input');
    this.frmEmail = this.querySelector('#phpcc-frm-email');
    this.frmEmailInput = this.querySelector('#phpcc-frm-email-input');
    this.frmCelular = this.querySelector('#phpcc-frm-celular');
    this.frmCelularInput = this.querySelector('#phpcc-frm-celular-input');
    this.frmCi = this.querySelector('#phpcc-frm-ci');
    this.frmCiInput = this.querySelector('#phpcc-frm-ci-input');
    this.frmFechaNacimientoInput = this.querySelector('#phpcc-frm-fecha-nacimiento-input');

    // INICIARLZAR EVENTOS
    this.btnMiUbicacionActual.addEventListener('click', this.accesoUbicacionActualModal.bind(this));
    this.btnCerrarModalMiUbicacion.addEventListener('click', this.cerrarModalMiUbicacion.bind(this));
    this.btnHutCoins.addEventListener('click', this.cambiarEstadoHutCoins.bind(this));
    this.btnInfoHutCoins.addEventListener('click', this.cambiarEstadoInfoHutCoins.bind(this));
    this.btnContinuar.addEventListener('click', this.procesoFormulario.bind(this));
    this.btnConfirmarModal.addEventListener('click', this.procesoConfirmacionModal.bind(this));
    this.btnCancelarModal.addEventListener('click', this.cerrarModalMiUbicacion.bind(this));
    document.addEventListener('click', this.detectarClickFueraDeElementosEspeciales.bind(this));

    this.frmNombreInput.addEventListener('input', this.habilitarBtnContinuar.bind(this));
    this.frmApellidoInput.addEventListener('input', this.habilitarBtnContinuar.bind(this));
    this.frmNombreInput.addEventListener('input', this.validarInputTexto.bind(this));
    this.frmApellidoInput.addEventListener('input', this.validarInputTexto.bind(this));
    this.frmEmailInput.addEventListener('input', this.habilitarBtnContinuar.bind(this));
    this.frmCelularInput.addEventListener('input', this.habilitarBtnContinuar.bind(this));
    this.frmCiInput.addEventListener('input', this.habilitarBtnContinuar.bind(this));


    // INICIALIZAR ELEMENTOS
    this.modalBackground.style.display = 'none';
    this.contenedorGeneralMiUbicacion.style.display = 'none';
    this.inicializarPaginaLocalStorage(0);
  }

  inicializarPaginaLocalStorage(intentos = 0) {
    // Verificar si Google Maps esta cargado
    if (typeof google == 'undefined') {
      // Limitar a 10 intentos para evitar bucles infinitos
      if (intentos < 10) {
        console.log('Google Maps no está cargado, esperando... Intento ' + (intentos + 1));
        setTimeout(() => {
          this.inicializarPaginaLocalStorage(intentos + 1);
        }, 500); // Esperar 0.5 segundos antes de volver a intentar
      } else {
        console.error('Google Maps no se cargó después de varios intentos');
      }
      return;
    }

    console.log('Google Maps cargado correctamente');
    this.configurarAutocompletadoDirecciones();
  }


  detectarClickFueraDeElementosEspeciales(event) {
    // Verificar si el modal general está visible
    if (this.contenedorGeneralMiUbicacion.style.display === 'flex') {
      // Si el clic fue dentro del modal body, no hacer nada
      if (this.contenedorModalBody.contains(event.target)) {
        return; // El clic fue dentro del contenido del modal, no cerramos
      }

      // Si el clic fue en el contenedor general pero fuera del modal body, cerrar todo
      if (this.contenedorGeneralMiUbicacion.contains(event.target)) {
        this.contenedorGeneralMiUbicacion.style.display = 'none';
        this.modalBackground.style.display = 'none';
      }
    }
  }

  cerrarModalMiUbicacion() {
    this.contenedorGeneralMiUbicacion.style.display = 'none';
  }

  cambiarEstadoHutCoins() {
    const estaActivado = this.btnHutCoins.classList.contains('activado');
    if (estaActivado) {
      this.btnHutCoins.classList.remove('activado');
      this.btnHutCoins.innerHTML = this.iconos.iconCheckBoxOff;
    } else {
      this.btnHutCoins.classList.add('activado');
      this.btnHutCoins.innerHTML = this.iconos.iconCheckBoxOn;
    }
  }

  cambiarEstadoInfoHutCoins() {
    const estaActivado = this.btnInfoHutCoins.classList.contains('activado');

    if (estaActivado) {
      this.btnInfoHutCoins.classList.remove('activado');
      this.btnInfoHutCoins.innerHTML = this.iconos.iconCheckBoxOff;
    } else {
      this.btnInfoHutCoins.classList.add('activado');
      this.contenedorTerminosCondiciones.classList.remove('politicas-terminos');
      this.btnInfoHutCoins.innerHTML = this.iconos.iconCheckBoxOn;
    }
  }

  async procesoFormulario() {
    const estaHabilitado = this.btnContinuar.classList.contains('desactivado');
    const estaHabilitado2 = this.btnInfoHutCoins.classList.contains('activado');
    if (!estaHabilitado && estaHabilitado2) {
      MensajeCargaDatos.mostrar('Procesando datos ...');
      // Verificar si el numero de celular ya esta ocupado

      await GestorClienteShopify.procesoCrearNuevoUsuario({
        nombre: this.frmNombreInput.value,
        apellido: this.frmApellidoInput.value,
        email: this.frmEmailInput.value,
        celular: this.frmCelularInput.value,
        ci: this.frmCiInput.value,
        nit: "",
        razon_social: "",
        fecha_nacimiento: this.frmFechaNacimientoInput.value,
        permisosHutCoins: this.btnHutCoins.classList.contains('activado'),
        direcciones: [
          {
            lat: this.coordenadas.lat,
            lng: this.coordenadas.lng,
            indicaciones: this.inputDireccion.value == "" ? "Plaza Principal de Warnes, Santa Cruz." : `${this.inputDireccion.value}, Santa Cruz.`,
            alias: "Ubicación de entrega"
          }
        ]
      });
    } else {
      if (!estaHabilitado2) {
        this.contenedorTerminosCondiciones.classList.add('politicas-terminos');
      }
    }
  }

  habilitarBtnContinuar() {
    const inputsForm = [
      this.frmNombreInput,
      this.frmApellidoInput,
      this.frmEmailInput,
      this.frmCelularInput,
      this.frmCiInput,
    ];

    const allFilled = inputsForm.every((input) => input.value.trim() !== '');
    if (allFilled) {
      this.btnContinuar.classList.remove('desactivado');
    } else {
      this.btnContinuar.classList.add('desactivado');
    }
  }

  async procesoConfirmacionModal() {
    const posicion = this.marcadorMovible.getPosition();
    this.coordenadas = { lat: posicion.lat(), lng: posicion.lng() };
    const ubicacionTexto = await AuxiliaresGlobal.obtenerDireccionDesdeCoordenadas(this.coordenadas.lat, this.coordenadas.lng);
    this.inputDireccion.value = ubicacionTexto;
    console.log('Coordenadas de dirección seleccionada:', {
      "coordenadas": this.coordenadas,
      "direccion": ubicacionTexto,
    });
    this.cerrarModalMiUbicacion();
  }

  configurarAutocompletadoDirecciones() {
    // Verificar que el input existe
    if (!this.inputDireccion) return;

    // Variable para almacenar el timer del debounce
    let timeoutId = null;

    // Variable para el servicio de Places
    this.placesService = new google.maps.places.AutocompleteService();

    // Escuchar el evento input
    this.inputDireccion.addEventListener('input', (e) => {
      // Limpiar el timer anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      const query = e.target.value.trim();

      // Si el input está vacío, ocultar sugerencias
      if (!query) {
        this.contenedorSugerencias.style.display = 'none';
        return;
      }

      // Configurar debounce (500ms)
      timeoutId = setTimeout(() => {
        this.buscarSugerenciasDirecciones(query);
      }, 500);
    });

    // Cerrar sugerencias al hacer clic fuera
    document.addEventListener('click', (e) => {
      if (!this.inputDireccion.contains(e.target) && !this.contenedorSugerencias.contains(e.target)) {
        this.contenedorSugerencias.style.display = 'none';
      }
    });
  }

  buscarSugerenciasDirecciones(query) {
    // Opciones para la búsqueda
    const opcionesBusqueda = {
      input: query,
      componentRestrictions: { country: 'bo' }, // Ajusta al país (Bolivia)
    };

    // Realizar la búsqueda
    this.placesService.getPlacePredictions(opcionesBusqueda, (predictions, status) => {
      // Limpiar contenedor de sugerencias
      this.contenedorSugerencias.innerHTML = '';

      if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        this.contenedorSugerencias.style.display = 'none';
        return;
      }

      // Limitar a 3 sugerencias
      const sugerencias = predictions.slice(0, 3);

      // Mostrar sugerencias
      sugerencias.forEach((sugerencia) => {
        const elemento = document.createElement('div');
        elemento.classList.add('psme-sugerencia-item');

        // Crear elemento p para el texto
        const textoElemento = document.createElement('p');
        textoElemento.textContent = sugerencia.description;
        elemento.appendChild(textoElemento);

        // Agregar evento de clic
        elemento.addEventListener('click', () => {
          this.seleccionarDireccion(sugerencia);
        });

        this.contenedorSugerencias.appendChild(elemento);
      });

      // Mostrar el contenedor
      if (sugerencias.length > 0) {
        this.contenedorSugerencias.style.display = 'block';
      } else {
        this.contenedorSugerencias.style.display = 'none';
      }
    });
  }

  seleccionarDireccion(sugerencia) {
    this.controlSeleccionInput = true;

    // Actualizar el valor del input
    this.inputDireccion.value = sugerencia.description;

    // Marcar que se ha seleccionado una dirección
    this.direccionSeleccionada = true;

    // Ocultar sugerencias
    this.contenedorSugerencias.style.display = 'none';

    // Obtener las coordenadas del lugar seleccionado
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: sugerencia.place_id }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const ubicacion = results[0].geometry.location;

        // Actualizar la variable de coordenadas usada de forma general
        this.coordenadas = {
          lat: ubicacion.lat(),
          lng: ubicacion.lng(),
        };

        this.accesoUbicacionActualModal();

        console.log('Coordenadas de direcciónn seleccionada:', this.coordenadas);
      }
    });
  }

  validarInputTexto(event) {
    // El elemento que disparó el evento
    const input = event.target;

    // Guarda la posición actual del cursor
    const cursorPos = input.selectionStart;

    // Filtra cualquier carácter que no sea letra o espacio
    const valorOriginal = input.value;
    const valorFiltrado = valorOriginal.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');

    // Solo actualiza si hay cambios
    if (valorOriginal !== valorFiltrado) {
      input.value = valorFiltrado;

      // Ajusta la posición del cursor
      input.setSelectionRange(cursorPos - (valorOriginal.length - valorFiltrado.length),
        cursorPos - (valorOriginal.length - valorFiltrado.length));
    }
  }

  // PROCESO DE SELECCION DE DIRECCION
  accesoUbicacionActualModal() {
    try {
      this.contenedorGeneralMiUbicacion.style.display = 'flex';

      // 0. Limpiar referencias anteriores si existen 
      this.limpiarReferenciasMapa();

      // 1. Verificar que el contenedor existe
      if (!this.contenedorMapaMiUbicacion) {
        console.error('Error: contenedorMapaMiUbicacion no encontrado');
        alert('Error: No se pudo cargar el mapa. Por favor recarga la página');
        return;
      }

      // 2. Verificar que Google Maps está disponible
      if (typeof google === 'undefined' || !google.maps) {
        console.error('Error: Google Maps no está disponible');
        alert('Error: No se pudo cargar Google Maps. Por favor recarga la página');
        return;
      }

      console.log('Entra a inicializarMapaEnvioDomicilio : ', this.coordenadas);

      // 3. Verificar coordenadas iniciales
      if (!this.coordenadas || !this.coordenadas.lat || !this.coordenadas.lng) {
        console.warn('Coordenadas no definidas, usando coordenadas por defecto');
        this.coordenadas = { lat: -17.8146, lng: -63.1560 }; // Santa Cruz, Bolivia por defecto
      }

      const configuracionMapa = {
        center: this.coordenadas,
        zoom: 16,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        scaleControl: false,
        rotateControl: false,
        panControl: false,
        disableDefaultUI: false,
      };

      // 4. Crear el mapa
      this.mapa = new google.maps.Map(this.contenedorMapaMiUbicacion, configuracionMapa);

      // 5. Crear el elemento sin cobertura
      this.crearElementoSinCobertura();

      // 6. Crear el marcador movible
      this.marcadorMovible = new google.maps.Marker({
        position: this.coordenadas,
        map: this.mapa,
        draggable: true,
        animation: google.maps.Animation.DROP,
      });

      // 7. Validar cobertura inicial al crear el marcador
      this.validarCobertura(this.coordenadas.lat, this.coordenadas.lng);

      // 8. Configurar el evento del marcador
      this.marcadorMovible.addListener('dragend', (evento) => {
        try {
          const posicion = this.marcadorMovible.getPosition();
          if (!posicion) {
            throw new Error('No se pudo obtener la posición del marcador');
          }

          this.coordenadas = { lat: posicion.lat(), lng: posicion.lng() };

          console.log('Coordenadas actualizadas: ', this.coordenadas);
          this.mapa.panTo(posicion);

          // Validar cobertura en la nueva posición
          this.validarCobertura(this.coordenadas.lat, this.coordenadas.lng);

        } catch (error) {
          console.error('Error al actualizar la posición:', error);
          alert('Error al actualizar la posición del marcador');
        }
      });

      // 9. Pedir la ubicación del usuario y actualizar el marcador a esa posición
      // Solo si no hay una dirección ya seleccionada
      if (this.direccionSeleccionada === true) {
        console.log('Dirección ya seleccionada, no se solicita geolocalización');
        return;
      }

      this.obtenerUbicacionUsuario();

    } catch (error) {
      console.error('Error en accesoUbicacionActualModal:', error);
      alert('Error al inicializar el mapa. Por favor recarga la página');
    }
  }

  // Método separado para obtener ubicación del usuario
  obtenerUbicacionUsuario() {
    if (!navigator.geolocation) {
      console.warn('Geolocalización no disponible en este navegador');
      return;
    }

    const opciones = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 300000 // 5 minutos
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        try {
          const miUbicacion = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          console.log('Ubicación del usuario obtenida:', miUbicacion);

          // Verificar que el marcador y mapa aún existen
          if (this.marcadorMovible && this.mapa) {
            this.marcadorMovible.setPosition(miUbicacion);
            this.mapa.panTo(miUbicacion);
            this.coordenadas = miUbicacion;

            // Validar cobertura en la ubicación del usuario
            this.validarCobertura(miUbicacion.lat, miUbicacion.lng);
          }

        } catch (error) {
          console.error('Error al procesar la ubicación del usuario:', error);
          alert('Error al obtener la ubicación: Por favor, verifique la configuración de ubicación de su dispositivo');
        }
      },
      (error) => {
        console.error('Error de geolocalización:', error);
        let mensaje = 'Error al obtener la ubicación: ';

        switch (error.code) {
          case error.PERMISSION_DENIED:
            mensaje += 'Permisos de ubicación denegados. Por favor, habilite los permisos de ubicación.';
            break;
          case error.POSITION_UNAVAILABLE:
            mensaje += 'Ubicación no disponible. Por favor, verifique su conexión GPS.';
            break;
          case error.TIMEOUT:
            mensaje += 'Tiempo de espera agotado. Por favor, intente nuevamente.';
            break;
          default:
            mensaje += 'Por favor, verifique la configuración de ubicación de su dispositivo.';
            break;
        }

        alert(mensaje);
      },
      opciones
    );
  }

  // Método para limpiar referencias del mapa anterior
  limpiarReferenciasMapa() {
    try {
      // Limpiar listeners del marcador
      if (this.marcadorMovible) {
        google.maps.event.clearInstanceListeners(this.marcadorMovible);
        this.marcadorMovible.setMap(null);
        this.marcadorMovible = null;
      }

      // Limpiar elemento sin cobertura del DOM
      if (this.elementoSinCobertura && this.elementoSinCobertura.parentNode) {
        this.elementoSinCobertura.parentNode.removeChild(this.elementoSinCobertura);
        this.elementoSinCobertura = null;
      }

      // Limpiar listeners del mapa
      if (this.mapa) {
        google.maps.event.clearInstanceListeners(this.mapa);
        this.mapa = null;
      }

    } catch (error) {
      console.error('Error al limpiar referencias del mapa:', error);
    }
  }

  // Método para crear el elemento de mensaje SIN COBERTURA
  crearElementoSinCobertura() {
    try {
      // Verificar si ya existe el elemento
      if (this.elementoSinCobertura) {
        console.warn('Elemento sin cobertura ya existe');
        return;
      }

      // Verificar que el contenedor existe
      if (!this.contenedorMapaMiUbicacion) {
        console.error('No se puede crear elemento sin cobertura: contenedor no encontrado');
        return;
      }

      this.elementoSinCobertura = document.createElement('div');
      this.elementoSinCobertura.innerHTML = 'SIN COBERTURA';
      this.elementoSinCobertura.style.cssText = `
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: var(--colorp-primary, #c8102e);
      color: white;
      padding: 10px 20px;
      font-weight: bold;
      border-radius: 8px;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      display: none;
      letter-spacing: 2.5px;
      font-size: 14px;
      user-select: none;
      pointer-events: none;
    `;

      // Asegurar que el contenedor tenga posición relativa
      this.contenedorMapaMiUbicacion.style.position = 'relative';
      this.contenedorMapaMiUbicacion.appendChild(this.elementoSinCobertura);

    } catch (error) {
      console.error('Error al crear elemento sin cobertura:', error);
    }
  }

  // Método para validar cobertura y mostrar/ocultar mensaje
  validarCobertura(lat, lng) {
    try {
      // Verificar que las coordenadas son válidas
      if (typeof lat !== 'number' || typeof lng !== 'number' ||
        isNaN(lat) || isNaN(lng)) {
        console.error('Coordenadas inválidas para validar cobertura:', { lat, lng });
        return;
      }

      // Verificar que GestorCobertura existe y tiene el método
      if (typeof GestorCobertura === 'undefined' ||
        typeof GestorCobertura.dentroDelPoligono !== 'function') {
        console.error('GestorCobertura no está disponible');
        return;
      }

      const dentroCobertura = GestorCobertura.dentroDelPoligono(lat, lng);

      if (dentroCobertura) {
        // Dentro de cobertura - ocultar mensaje
        if (this.elementoSinCobertura) {
          this.elementoSinCobertura.style.display = 'none';
        }
        if (this.btnConfirmarModal) {
          this.btnConfirmarModal.classList.remove('desactivado');
        }
        console.log('Ubicación dentro de cobertura');
      } else {
        // Fuera de cobertura - mostrar mensaje
        if (this.elementoSinCobertura) {
          this.elementoSinCobertura.style.display = 'block';
        }
        if (this.btnConfirmarModal) {
          this.btnConfirmarModal.classList.add('desactivado');
        }
        console.log('Ubicación fuera de cobertura');
      }

    } catch (error) {
      console.error('Error al validar cobertura:', error);
    }
  }

  // Método para destruir completamente el mapa (llamar cuando cierres el modal)
  destruirMapa() {
    try {
      this.limpiarReferenciasMapa();

      // Limpiar el contenedor del mapa
      if (this.contenedorMapaMiUbicacion) {
        this.contenedorMapaMiUbicacion.innerHTML = '';
      }

      // Resetear coordenadas si es necesario
      // this.coordenadas = null;

    } catch (error) {
      console.error('Error al destruir el mapa:', error);
    }
  }
}

customElements.define('crear-cuenta', CrearCuenta);